import { StrictMode } from "react"

import { QueryClientProvider } from "@tanstack/react-query"
import { IDirective } from "angular"
import { createRoot } from "react-dom/client"

import { queryClient } from "@/query/queryClient"

import { LoginPageController } from "./LoginPage.controller"
import { LoginPage } from "./LoginPage"

export function LoginPageDirective(): IDirective {
  return {
    restrict: "E",
    controller: "LoginPageController",
    link: function (scope, element, _attributes, controller) {
      const root = createRoot(element[0])

      root.render(
        <StrictMode>
          <QueryClientProvider client={queryClient}>
            <LoginPage controller={controller as LoginPageController} />
          </QueryClientProvider>
        </StrictMode>,
      )

      // Clean up React component when the Angular component is destroyed
      scope.$on("$destroy", () => {
        root.unmount()
      })
    },
  }
}
